import * as strings from '../../../../assets/strings';
import { AvisoGeralService } from './aviso-geral.service';
import { NavegacaoService } from '../../../core/navegacao.service';
import { CredenciaisService } from '../../../core/credenciais.service';
import { Component, ElementRef, EventEmitter, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { LocalStorageService } from '../../../core/local-storage.service';
import { MatDialog } from "@angular/material/dialog";
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { catchError, first, tap } from 'rxjs/operators';
import { HttpBaseService } from '../../../core/http-base.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { Subscription, throwError, timer } from 'rxjs';
import { startWith, map, take } from "rxjs/operators";

@Component({
  templateUrl: './aviso-geral.component.html',
  styleUrls: ['./aviso-geral.component.scss']
})
export class AvisoGeralComponent implements OnInit {

  public hoje: any = new Date(moment(Date.now()).format('YYYY-MM-DD'));
  theme: any;
  url: string;
  src1: string = 'https://app.powerbi.com/view?r=eyJrIjoiOGYxM2RmY2MtMTkzNC00MzEwLTgwYjYtN2ZhNjk4NDBiYzExIiwidCI6Ijc0MWY4Nzc5LTU3MjUtNDQxOS04YWJkLTFiOTc3ZWFlNzFhYSJ9';//'https://app.powerbi.com/view?r=eyJrIjoiYTE0OWE4NTAtOWEzMS00OTJkLThlZWEtZjVmMDFlNGNjZTBjIiwidCI6Ijc0MWY4Nzc5LTU3MjUtNDQxOS04YWJkLTFiOTc3ZWFlNzFhYSJ9';
  //src2: string = 'https://app.powerbi.com/view?r=eyJrIjoiNGVjOTYzOTItODc1My00MTlkLThjODAtOGUxYWVkZDUxNzU1IiwidCI6IjgxNDg2ZjYwLWFhODYtNGE2NC1hMmZjLWVhYTlmZjdhY2UzYSJ9';
  //src3: string = 'https://app.powerbi.com/view?r=eyJrIjoiYmExZGU0OTYtZTUyOC00YjQzLWExZDItMDI5ZjU0MzU4NjA3IiwidCI6IjgxNDg2ZjYwLWFhODYtNGE2NC1hMmZjLWVhYTlmZjdhY2UzYSJ9';

  showDashboard: boolean = false;
  showAniversariante: boolean = false;
  showNoticia: boolean = false;

  nomePessoa: string;
  fotoPessoa: any;
  textoParabens: any;

  tituloNoticia: string;
  noticia: string;
  fotoNoticia: string;
  link: string;
  indexFoto:number;

  numeroOrdem: number;
  @Output() numberGenerated = new EventEmitter<number>();
  @ViewChild('iframe', { static: true }) iframe: ElementRef;

  //parametros pra timer de verificar agenda
  countDown: Subscription;
  counter;
  tick = 1000;
  sequencia: number = 0;
  countadorOrdem: number = 60;//60 segundos = 1 minuto

  //timeInterval = 20000;

  currentIndexGeral = 0;
  intervalGeral: any;

  currentIndexFoto = 0;
  intervalFoto: any;

  currentIndexNoticia = 0;
  intervalNoticia: any;

  public urlDownload: string = environment.urlDownloadFile;

  constructor(private loginService: AvisoGeralService,
    public credenciaisService: CredenciaisService,
    private localStorageService: LocalStorageService,
    private navegacaoService: NavegacaoService,
    private http: HttpBaseService,
    public dialog: MatDialog,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private httpClient: HttpClient,
  )
  { }

  ngAfterViewInit() {
    //console.log("ngAfterViewInit")
    this.loopGeral();//this.rotinaAtualizar();    
  }
  
  ngOnInit() {
    //console.log("ngOnInit")
    //this.loopGeral();
    //this.iframe.nativeElement.src = this.src1;
    // this.http.get("/dominio/allAniversario", false).subscribe((info) => {
     //console.log("allAniversario",info)
    //   this.timeInterval = parseInt(info[0].valorDominio);
    //   this.countadorOrdem = parseInt(info[0].qtdDominio);
      
    // });
  }

  gerarOrdem(): void {
    // this.numeroOrdem = Math.floor(3 * Math.random());//this.numberGenerated.emit(this.numeroOrdem);    
    //if(this.sequencia == 0) { this.cardNoticia(); }
    //if(this.sequencia == 1) { this.cardAniversariante(); }
    //if(this.sequencia == 2) { this.cardDashboard(); }

    //this.sequencia++;
    //if (this.sequencia == 3) { this.sequencia = 0; }
  }

  stopLoopNoticia() {
    if (this.intervalNoticia) {
      clearInterval(this.intervalNoticia);
    }
  }

  startLoopNoticia() {
    this.stopLoopNoticia();
    this.cardNoticia();
  }

  stopLoopAniversario() {
    if (this.intervalFoto) {
      clearInterval(this.intervalFoto);
    }
  }

  startLoopAniversario() {
    this.stopLoopAniversario();
    this.cardAniversariante();;
  }

  loopGeral() {  
    //this.startLoopAniversario();  
    this.cardNoticia();
    this.intervalGeral = setInterval(() => {
      //console.log("loopGeral2--this.currentIndexGeral", this.currentIndexGeral);
      if (this.currentIndexGeral == 3) { this.currentIndexGeral = 0; }

      switch (this.currentIndexGeral) {
        case 0:
          //console.log("loopGeral-- case 0", this.currentIndexGeral);
          this.stopLoopAniversario();
          this.startLoopNoticia();
          break;
        case 1:
          //console.log("loopGeral-- case 1", this.currentIndexGeral);
          this.stopLoopNoticia();
          this.startLoopAniversario();
          break;
        case 2:
          //console.log("loopGeral-- case 2", this.currentIndexGeral);
          //this.stopLoopAniversario();
          //this.stopLoopNoticia();
          this.cardDashboard();
          break;
      }
      this.currentIndexGeral = this.currentIndexGeral + 1;// % 3;
      //console.log("loopGeral3--this.currentIndexGeral", this.currentIndexGeral);
    }, 60000);
  }

  rotinaAtualizar() {
    this.counter = this.countadorOrdem;
    this.countDown = timer(0, this.tick).subscribe((count) => {
      --this.counter;

      if (this.counter == 0) {
        //console.log('timer completed', count, this.counter);
        this.gerarOrdem();

        if (this.countDown) {
          this.pararRotina();
          this.rotinaAtualizar();
        }
      }
      //console.log('this.counter', this.counter);
    });
  }

  pararRotina() {
    this.countDown.unsubscribe();
    this.countDown = null;
  }

  cardDashboard(): void {
    this.stopLoopAniversario();
    this.stopLoopNoticia();
    //this.countadorOrdem = 5; 
    var x = document.getElementById("diviframe");
    x.style.display = "block";

    // if (x.style.display === "none") {
    //   x.style.display = "block";
    // } 
    // else {
    //   x.style.display = "none";
    // }
    this.http.get("/dominio/allTipoDashboard", false).subscribe((info) => {
      this.src1 = info[0].detalhamento;
      this.showDashboard = true;
      this.showAniversariante = this.showNoticia = !this.showDashboard;
      this.iframe.nativeElement.src = this.src1;
    });
    //this.numeroOrdem = Math.floor(3 * Math.random());//this.numberGenerated.emit(this.numeroOrdem);
    //if (this.numeroOrdem == 1) { this.iframe.nativeElement.src = this.src1; }
    //if (this.numeroOrdem == 2) { this.iframe.nativeElement.src = this.src2; }
    //if (this.numeroOrdem == 3) { this.iframe.nativeElement.src = this.src3; }
  } 

  proximaFotoLoop(lista:any) {
    if(this.currentIndexFoto==lista.length){this.currentIndexFoto=0;}
    this.intervalFoto = setInterval(() => {
      this.currentIndexFoto = (this.currentIndexFoto + 1) % lista.length;
      this.nomePessoa = lista[this.currentIndexFoto].apelido;//lista[this.currentIndexFoto].nome,
      this.fotoPessoa = this.urlDownload + lista[this.currentIndexFoto].foto;
      this.textoParabens = lista[this.currentIndexFoto].mensagem;
    }, 20000); // Troca a imagem a cada 20 segundos
  }

  cardAniversariante() {
    //this.countadorOrdem = 15;
    var x = document.getElementById("diviframe");
    x.style.display = "none";

    this.http.get("/Aniversariante/ExibirAniversarianteDia/TV", false).subscribe((lista) => {
      //console.log("cardAniversariante",lista)

      if(lista!=null)
      {
        if(lista.length>0)
          {
            this.showAniversariante = true;
            this.showDashboard = this.showNoticia = !this.showAniversariante;
            this.nomePessoa =  lista[0].apelido;//lista[0].nome,
            this.fotoPessoa = this.urlDownload + lista[0].foto;
            this.textoParabens = lista[0].mensagem;
            
            if(lista.length>1)
            {this.proximaFotoLoop(lista);}
          }
      }      
      else{
        this.cardDashboard();
      } 
    });
  }

  proximaNoticiaLoop(lista:any) {
    if(this.currentIndexNoticia==lista.length){this.currentIndexNoticia=0;}

    this.intervalNoticia = setInterval(() => {
      //console.log("proximaNoticiaLoop", lista[this.currentIndexNoticia])
      this.currentIndexNoticia = (this.currentIndexNoticia + 1) % lista.length;
      this.tituloNoticia = lista[this.currentIndexNoticia].titulo,
      this.fotoNoticia = lista[this.currentIndexNoticia].imagem
      this.noticia = lista[this.currentIndexNoticia].detalhe
      this.link = "http://nossl.quickchart.io/qr?size=150&text=" + lista[this.currentIndexNoticia].link;      
    }, 15000); // Troca a noticia a cada 20 segundos
  }

  cardNoticia() {
    //this.countadorOrdem = 20; 
    var x = document.getElementById("diviframe");
    x.style.display = "none";

    this.http.get("/Noticia/CarregarNoticia", false).subscribe((lista) => {
      //console.log("cardNoticia",lista)
      if(lista!=null)
      {
        if(lista.length>0)
          {
            this.showNoticia = true;
            this.showDashboard = this.showAniversariante = !this.showNoticia;
    
            this.tituloNoticia = lista[0].titulo,
            this.fotoNoticia = lista[0].imagem
            this.noticia = lista[0].detalhe
            this.link = "http://nossl.quickchart.io/qr?size=150&text=" + lista[0].link;
            this.proximaNoticiaLoop(lista);
            
            //if(lista.length>1)
            //{
            //  this.proximaNoticiaLoop(lista);
            //}
          }
      }      
      else{
        this.cardDashboard();
      }
    });
  }

  
}

